import './ReadersOperationsModal.css';
import Modal from 'react-modal';
import { useCallback, useEffect, useState } from 'react';
import { customStyles } from '../Modal/ModalComponent';
import { IoClose } from 'react-icons/io5';
import Button from '../Button/Button';
import { TbEditCircle } from 'react-icons/tb';
import Select from '../Select/Select';
import { useUserStore } from '../../contexts/userStore';
import { debounce } from '../../utils/timer';
import Form from '../Form/Form';
import List from '../List/List';
import { getReaderModelByEnum, ReaderModel } from '../../constants/readers-model';
import AsyncSelect from "react-select/async";
import ReceptionPhoto from '../ReceptionPhoto/ReceptionPhoto';
import CondoUserService from '../../services/CondoUserService';
import ReadersService from '../../services/ReadersService';
import { useAuth } from '../../contexts/auth';
import { NotificationManager } from 'react-notifications';

export function ReadersOperationsModal(props) {
   const [modalIsOpen, setModalIsOpen] = useState(false);
   const [readers, setReaders] = useState([]);
   const { selectedCondominio, selectedLicenceId } = useUserStore();
   const { user } = useAuth();
   const [optionsSelectCondoUsers, setOptionsSelectCondoUsers] = useState([]);
   const [searchReader, setSearchReader] = useState("");
   const [readerModel, setReaderModel] = useState(`0`);
   const [operation, setOperation] = useState("0");
   const [selectedReaders, setSelectedReaders] = useState([]);
   const [selectedCondoUser, setSelectedCondoUser] = useState();

   function close() {
      setReaders([]);
      setOptionsSelectCondoUsers([]);
      setSearchReader();
      setOperation("0");
      setSelectedCondoUser();
      setSelectedReaders([]);
      setModalIsOpen(false);
   }

   const promiseUserOptions = async (inputValue) =>
      new Promise(async (resolve) => {
         const usersResponse = await CondoUserService.listCondoUsersPaginated(
            1,
            inputValue,
            user.userData.selectedOrganizationId,
            { collumnTitle: "createdAt", orderDirection: "DESC" }
         );
         setOptionsSelectCondoUsers(usersResponse.data?.items);

         const transformedData = usersResponse.data?.items?.map((item) => ({
            value: item.id,
            label: item.name,
         }));

         resolve(transformedData);
      });

   const fetchUsersDebounce = useCallback(
      debounce(promiseUserOptions, 700), []
   );

   async function fetchReaders(search, modelArg) {
      try {
         const model = modelArg !== '0' ? modelArg : null;
         const response = await ReadersService.getPaginatedReaders(1, search, model, selectedCondominio, 'name');
         return response.data?.items;
      } catch (error) {
         console.error('Error fetching readers:', error);
         return [];
      }
   }

   const fetchReadersDebounce = useCallback(
      debounce(fetchReaders, 700), []
   );

   useEffect(() => {
      async function loadReaders() {
         const readers = await fetchReadersDebounce(searchReader, readerModel);
         setReaders(readers);
      }
      loadReaders();
   }, [searchReader]);

   useEffect(() => {
      async function loadReaders() {
         const readers = await fetchReaders(searchReader, readerModel);
         setReaders(readers);
      }
      loadReaders();
   }, [selectedCondominio, readerModel, modalIsOpen]);

   async function handleSubmit(event) {
      event.preventDefault();
      if (!operation || !['1', '2', '3'].includes(operation)) {
         NotificationManager.warning("", "Operação inválida");
         return;
      }
      if (!selectedReaders || selectedReaders.length === 0) {
         NotificationManager.warning("", "Nenhuma leitora selecionada");
         return;
      }
      const payload = {
         operation: Number(operation),
         readers: selectedReaders.map(reader => reader.uuid)
      };
      if (operation === '2') {
         if (!selectedCondoUser || !selectedCondoUser.uuid) {
            NotificationManager.warning("", "Nenhum usuário selecionado");
            return;
         }
         payload.user = selectedCondoUser?.uuid;
      }
      await ReadersService.sendReadersOperation(selectedCondominio, selectedLicenceId, payload.operation, payload);
      close();
   }

   const handleUserSelect = (selectedOption) => {
      const userSelected = optionsSelectCondoUsers.find((user) => {
         return user.id === selectedOption.value;
      });
      setSelectedCondoUser(userSelected);
   };

   function onCheckReaderChange(reader) {
      if (selectedReaders.find(sReader => sReader.uuid === reader.uuid)) {
         setSelectedReaders(selectedReaders.filter(r => r.uuid !== reader.uuid));
         return;
      }
      setSelectedReaders([
         ...selectedReaders,
         reader,
      ]);
   }

   function onCheckAllChange(e) {
      if (e.target.checked) {
         setSelectedReaders(readers);
         return;
      }
      setSelectedReaders([]);
   }

   return (
      <>
         <Button
            className="button-white"
            style={{ width: '210px' }}
            icon={<TbEditCircle size={20} />}
            label="Operações nas Leitoras"
            onClick={() => setModalIsOpen(true)}
         />
         <Modal
            isOpen={modalIsOpen}
            onRequestClose={() => close()}
            style={{
               ...customStyles,
               content: {
                  ...customStyles.content,
                  width: '700px',
                  maxWidth: '90dvw',
                  padding: '36px'
               }
            }}
            contentLabel="Operações nas Leitoras"
         >
            <div className='modal-header mb-0!'>
               <h2>Operações nas Leitoras</h2>
               <button className="close-button" onClick={() => close()}><IoClose /></button>
            </div>
            <div className='modal-body'>
               <Form
                  handleSubmit={handleSubmit}
                  type={props.type}
                  handleClickCancel={() => close()}
                  saveButtonText={'Executar'}
               >
                  <Select
                     labelText="Operação"
                     value={operation}
                     onChange={({ target }) => setOperation(target.value)}
                     required={true}
                     options={[
                        { value: '0', text: 'Escolha a operação' },
                        { value: '1', text: 'Apagar todos os usuários da(s) leitora(s)' },
                        { value: '2', text: 'Remover usuário da(s) leitora(s)' },
                        { value: '3', text: 'Sincronizar leitora(s) com a cloud' }
                     ]}
                  />
                  <div className="readers-list-wrapper">
                     <h3 className='text-(--textColor) text-left w-full text-sm! mb-0.5!'>Selecione as leitoras</h3>
                     <div className='readers-filters grid grid-cols-2 [&_.select-wrapper]:w-full! [&_.select-wrapper]:max-w-none! w-full gap-2 mb-2!'>
                        <input
                           name="searchReader"
                           placeholder="Buscar Leitoras"
                           className="input-form search-input w-full! max-w-none!"
                           type="text"
                           value={searchReader}
                           onChange={(e) => setSearchReader(e.target.value)}
                           style={{ backgroundColor: `var(--inputBackgroundColor)` }}
                        />
                        <Select
                           value={readerModel}
                           onChange={({ target }) => setReaderModel(target.value)}
                           required={true}
                           options={[
                              { value: `0`, text: 'Busque por modelo' },
                              ...Object.entries(ReaderModel).map(([, model]) => (
                                 { value: model.key, text: model.name }
                              )),
                           ]}
                        />
                     </div>
                     <List
                        listEntityName={"readers"}
                        selectableRows={false}
                        collumsObjIndex={[
                           {
                              collumnLabel: "",
                              type: "custom",
                              custom: ({ row }) => (
                                 <input type='checkbox' checked={selectedReaders?.find(r => r.uuid === row.uuid)} onChange={(e) => onCheckReaderChange(row)} />
                              ),
                              // select all
                              customHeader: () => (
                                 <input type='checkbox' className="-ml-[8px]!" onChange={(e) => onCheckAllChange(e)} checked={selectedReaders?.length === readers?.length} />
                              )
                           },
                           {
                              collumnLabel: "Nome",
                              index: "name",
                              type: "text",
                           },
                           {
                              collumnLabel: "Modelo",
                              index: "model",
                              type: "text",
                              custom: ({ row }) => getReaderModelByEnum(row.model)?.name
                           },
                           {
                              collumnLabel: "Tipo",
                              index: "configuration.authenticationType",
                              type: "text",
                           },
                        ]}
                        data={readers}
                     />
                  </div>
                  {operation === '2' && (
                     <div className='w-full flex-col items-start'>
                        <h3 className='text-(--textColor) text-left w-full text-sm! mb-0.5!'>Selecione o usuário</h3>
                        <div style={{ width: '100%', height: "70px", textAlign: 'left' }}>
                           <AsyncSelect
                              className="basic-single reception-search-user-select"
                              cacheOptions
                              defaultOptions
                              loadOptions={fetchUsersDebounce}
                              onChange={handleUserSelect}
                           />
                        </div>
                        {selectedCondoUser && (
                           <div className=''>
                              <div className='w-[200px]'>
                                 <ReceptionPhoto
                                    name={selectedCondoUser?.name || ""}
                                    urlLogo={selectedCondoUser?.signed_url_photo?.replace("[:STORAGE_ADDRESS:]", window.location.hostname) || ""}
                                 />
                              </div>
                           </div>
                        )}
                     </div>
                  )}
               </Form>
            </div>
         </Modal>
      </>
   );
}
